import moment from 'moment-timezone';
import { useSelector } from 'react-redux';

import { getLastMarkDateConfig } from '../helpers/lastMarkDate';

import { getUserId, getParentUserId } from '../redux/auth/selectors';

/**
 * Hook zawierjący funkcje służące operacjom na datach
 *
 */
const useDateOperations = () => {
  const parentUserId = useSelector(getParentUserId);
  const userId = useSelector(getUserId);

  const id = parentUserId ?? userId;

  const generateDefaultDate = (timestamp: number | undefined = undefined) => {
    if (timestamp) {
      return moment(timestamp, 'X');
    }

    if (id) {
      const userTimestamp = getLastMarkDateConfig(id)?.selectedDate;

      if (userTimestamp) {
        return moment(userTimestamp, 'X');
      }
    }

    return undefined;
  };

  return { generateDefaultDate };
};

export default useDateOperations;
